import React from "react";

import "./styles.scss";
import ChatHistoryMain from "../../esg-chat/chat-history";


const PromptHistory = () => {
    return (
        <>
            <ChatHistoryMain model="Company" searchBy="Public" promptEvaluation={true} />           
        </>
    )
}

export default PromptHistory;